export const PRICES_FOR_TITLE = [
  {
    title: "за об'єкт",
    value: "4",
  },
  {
    title: "за м²",
    value: "1",
  },
  //   {
  //     title: "за гектар",
  //     value: "3",
  //   },
  {
    title: "за сотку",
    value: "2",
  },
];

export const PRICES_FOR_TITLE_FILTERS = [
  {
    title: "об'єкт",
    value: "4",
  },
  {
    title: "м²",
    value: "1",
  },
  //   {
  //     title: "за гектар",
  //     value: "3",
  //   },
  {
    title: "сотка",
    value: "2",
  },
];

export const TAGS = [
  "label_is_actual",
  "label_not_actual",
  "label_dont_call_back",
  "label_cooperation",
  "label_fake",
  "label_without_children",
  "label_without_animals",
  "label_without_students",
  "label_without_foreigners",
];

export const SELECTION_TAGS = [
  { title: "Топ", value: "label_top" },
  { title: "Рекомендовано", value: "label_recomendation" },
  { title: "Показ", value: "label_showing" },
];

export const XHOUSE_COMPANY_ID = [
  "0d08ae83370263b3f320a0eb136c1a30",
  "4c02e08dc82183d35a4ed2eef4829a0d",
  "ff010e0f671a28695142ab2f02d7b8c9",
  "ae191c45f814262d747cf24d7f3799fd",
  "102c09bb1882c9bd2ca0ce0f0eb1a9f3",
  "b43e91fce0a37a44734dcde3d08b7296",
  "c863b698f1502555b98034dc6f81f8bb",
  "0022b718e5a80c0e3992686fd10ff1dc",
];
